module.exports = __webpack_public_path__ + "img/datav_bg1.8bc434f6.png";